import { jsx as e, jsxs as p, Fragment as U } from "react/jsx-runtime";
import { L as J, a4 as Be, cy as Me, P as Ae, x as Ke, ap as x, cz as je, cA as Ue, w as $e, Y as k, cB as O, cC as Ye, cD as Qe, cE as Le, cF as Fe, cG as F, cH as Je, cI as Xe, cJ as Te, aT as ue, Z as et, bH as M, cK as tt, cL as at, cM as Pe, cN as Re, cO as ze, cP as nt, cQ as Oe, cR as Ee, b6 as pe, cS as rt, cT as lt, cU as st, cV as we, cW as Ce, v as it, cX as ot, F as ct, cY as E, cZ as dt, az as Ie, D as X, _ as Ge, aC as ut, c_ as Ve, aw as K, am as I, av as pt, au as j, E as mt, as as ft, c$ as ht, cw as ke, d0 as gt, d1 as xt, d2 as yt, d3 as bt, d4 as Nt, d5 as vt, d6 as wt, d7 as Ct, d8 as It } from "../../TabGroup-B4jOGf3W.js";
import { d9 as Ba, ax as Ma, de as Aa, dr as $a, cx as La, df as Fa, ds as Ta, dh as Pa, di as Ra, dk as za, dj as Oa, dc as Ea, dg as Ga, db as Va, dp as _a, dl as Wa, dd as Za, dq as qa, dn as Ha, da as Ka, dm as ja } from "../../TabGroup-B4jOGf3W.js";
import { useState as Y, useRef as ie, useMemo as L, useImperativeHandle as kt, useEffect as Q } from "react";
import { q as Dt, A as St, v as _e } from "../../timing-BFaISC6B.js";
import { i as oe } from "../../references-BRMYEcTr.js";
import "immutable";
import "react-dom";
import "@tanstack/react-virtual";
import { c as B } from "../../cn-B6yFEsav.js";
import { Check as Bt } from "lucide-react";
import "@radix-ui/react-checkbox";
import "luxon";
import "react-day-picker";
import { Label as Mt } from "radix-ui";
import "@radix-ui/react-switch";
import "fast-levenshtein";
import "fuzzy";
import "fast-deep-equal";
import "clsx";
import "tailwind-merge";
import { S as At } from "../../Sandwich-eowxQOgu.js";
import { a as $t, S as Lt } from "../../skeleton-BsC3YUir.js";
import { themeCSSVars as S } from "../../legacy/themes/index.js";
function Ft(t) {
  return t.length === 0 ? [] : Array.isArray(t[0]) && t[0].length === 2 && Array.isArray(t[0][1]) ? t.filter(([, a]) => a.length > 0) : [["", t]];
}
function Tt(t, a) {
  return t ? typeof t == "string" && M(t) ? /* @__PURE__ */ e(x, { icon: t, size: a }) : t : null;
}
function ma(t) {
  const {
    options: a,
    value: n,
    onChange: o,
    placeholder: r = "Search...",
    emptyMessage: l = "No results found",
    disabled: s,
    invalid: i,
    size: d = "small",
    align: u = "start",
    className: m,
    style: f,
    floatingAppearance: h,
    maxHeight: y = 300,
    maxWidth: D = 440,
    triggerDataAttrs: T,
    innerRef: P,
    handleRef: w,
    id: $,
    portalTarget: ee,
    contentRef: te,
    children: v,
    ...G
  } = t, [N, A] = Y(!1), me = J(), ae = ie(null), fe = ie(null), he = ie(null), [ge, V] = Y(0), _ = L(() => Ft(a), [a]), W = L(() => _.flatMap(([, c]) => c), [_]), ne = L(
    () => n == null ? void 0 : W.find((c) => oe(c.value, n)),
    [W, n]
  ), [R, z] = Be(ne?.label ?? "");
  kt(
    w,
    () => ({
      clear: () => z(""),
      focus: () => ae.current?.focus(),
      blur: () => ae.current?.blur()
    }),
    [z]
  );
  const Ze = (c) => {
    ae.current = c, et(c, P);
  }, re = R.length > 0 && R !== ne?.label, Z = L(() => {
    if (!re) return _;
    const c = Dt(W, R, (b) => b.label);
    return c.length > 0 ? [["", c]] : [];
  }, [re, R, _, W]), C = L(() => {
    const c = [];
    return Z.forEach(([, b], q) => {
      b.forEach((g, se) => {
        g.disabled || c.push({ key: `${q}-${se}-${g.label}`, option: g });
      });
    }), c;
  }, [Z]), le = C[ge]?.key;
  Q(() => {
    if (!N) return;
    const c = C.findIndex(
      ({ option: b }) => n != null && oe(b.value, n)
    );
    V(c >= 0 ? c : 0);
  }, [N, C, n]), Q(() => {
    !N || le == null || he.current?.scrollIntoView({ block: "nearest" });
  }, [N, le]);
  function xe(c) {
    c.disabled || (o?.(c.value), z(c.label), A(!1));
  }
  function qe(c) {
    if (!s)
      switch (c.key) {
        case "ArrowDown":
          c.preventDefault(), N ? C.length > 0 && V((b) => (b + 1) % C.length) : A(!0);
          break;
        case "ArrowUp":
          c.preventDefault(), N ? C.length > 0 && V((b) => (b - 1 + C.length) % C.length) : A(!0);
          break;
        case "Enter":
          if (N) {
            c.preventDefault();
            const b = C[ge];
            b && xe(b.option);
          } else
            c.stopPropagation();
          break;
        case "Escape":
          N && (c.preventDefault(), ye(!1));
          break;
      }
  }
  function ye(c) {
    A(c), c || z(ne?.label ?? "");
  }
  return /* @__PURE__ */ e(Me, { shouldFilter: !1, loop: !0, children: /* @__PURE__ */ p(Ae, { modal: !1, open: N, onOpenChange: ye, children: [
    /* @__PURE__ */ e(Ke, { asChild: !0, children: /* @__PURE__ */ p(
      "div",
      {
        ref: fe,
        "data-invalid": i || void 0,
        className: B(
          Ue,
          je[d],
          // The focusable element is the inner input, so move the focus ring to the wrapper.
          "cursor-text focus-within:border-(--palette-N500)",
          s && "cursor-not-allowed border-(--palette-N100) bg-(--palette-N100) text-(--palette-N400)",
          m
        ),
        style: f,
        children: [
          /* @__PURE__ */ e(
            "input",
            {
              ref: Ze,
              id: $,
              type: "text",
              role: "combobox",
              "aria-expanded": N,
              "aria-controls": me,
              autoComplete: "off",
              disabled: s,
              placeholder: r,
              value: R,
              onChange: (c) => {
                z(c.target.value), N || A(!0);
              },
              onFocus: () => A(!0),
              onClick: () => A(!0),
              onKeyDown: qe,
              className: "min-w-0 flex-1 bg-transparent outline-none placeholder:text-(--palette-N300) disabled:cursor-not-allowed",
              ...T
            }
          ),
          /* @__PURE__ */ e(
            "span",
            {
              className: "flex shrink-0 pointer-events-none opacity-60 transition-transform data-[open=true]:rotate-180",
              "data-open": N,
              children: /* @__PURE__ */ e(x, { icon: "Down", size: 16 })
            }
          )
        ]
      }
    ) }),
    /* @__PURE__ */ p(
      $e,
      {
        ref: te,
        container: ee,
        align: u,
        onOpenAutoFocus: (c) => c.preventDefault(),
        onCloseAutoFocus: (c) => c.preventDefault(),
        onInteractOutside: (c) => {
          fe.current?.contains(c.target) && c.preventDefault();
        },
        className: B("min-w-(--radix-popover-trigger-width)", h?.className),
        style: {
          maxHeight: Qe(y),
          maxWidth: Ye(D),
          ...h?.style
        },
        ...O(G),
        children: [
          k(v),
          /* @__PURE__ */ p(Le, { id: me, children: [
            re && Z.length === 0 && /* @__PURE__ */ e(Fe, { children: l }),
            /* @__PURE__ */ e(F, { collection: Z, children: ([c, b], q) => /* @__PURE__ */ p(U, { children: [
              q > 0 && /* @__PURE__ */ e(Je, {}),
              /* @__PURE__ */ e(Xe, { heading: c || void 0, children: /* @__PURE__ */ e(F, { collection: b, children: (g, se) => {
                const be = n != null && oe(n, g.value), H = `${q}-${se}-${g.label}`, Ne = H === le;
                return /* @__PURE__ */ e(
                  Te,
                  {
                    value: H,
                    ref: Ne ? he : void 0,
                    disabled: g.disabled,
                    "aria-selected": be,
                    "aria-current": Ne || void 0,
                    className: "gap-2 cursor-pointer group/option",
                    onSelect: () => xe(g),
                    onMouseMove: () => {
                      if (g.disabled) return;
                      const ve = C.findIndex((He) => He.key === H);
                      ve >= 0 && V(ve);
                    },
                    ...ue("Body/M/Book"),
                    ...O(g),
                    children: g.children != null ? k(g.children, {
                      label: g.label,
                      value: g.value
                    }) : /* @__PURE__ */ p(U, { children: [
                      Tt(g.icon, 16),
                      /* @__PURE__ */ e("span", { className: "truncate flex-1", children: g.label }),
                      be && /* @__PURE__ */ e(Bt, { className: "h-4 w-4 shrink-0" })
                    ] })
                  },
                  H
                );
              } }) })
            ] }) })
          ] })
        ]
      }
    )
  ] }) });
}
const ce = 3;
function fa({ crumbs: t, syncHtmlTitle: a = !1 }) {
  const n = t.at(-1)?.label;
  Q(() => {
    !a || n === void 0 || (document.title = typeof a == "string" ? `${a} > ${n}` : n);
  }, [a, n]);
  const o = t.at(-3), r = t.length > ce ? t.slice(1, -2) : [], l = t.slice(-Math.min(ce, t.length) + 1);
  return /* @__PURE__ */ e(tt, { children: /* @__PURE__ */ p(at, { children: [
    t[0] && /* @__PURE__ */ e(De, { ...t[0], isLast: t.length === 1 }),
    t.length > ce ? /* @__PURE__ */ p(U, { children: [
      /* @__PURE__ */ e(Pe, { children: /* @__PURE__ */ p(Re, { children: [
        /* @__PURE__ */ e(
          ze,
          {
            disabled: r.length === 0,
            className: "flex items-center gap-1 disabled:opacity-70",
            "aria-label": "Toggle menu",
            children: /* @__PURE__ */ e(nt, { className: "size-4" })
          }
        ),
        /* @__PURE__ */ e(Oe, { align: "start", children: /* @__PURE__ */ e(F, { collection: r, children: ({ href: s, onClick: i, disabled: d, children: u, label: m }) => /* @__PURE__ */ e(Ee, { asChild: !0, disabled: d, children: i ? /* @__PURE__ */ e(pe, { disabled: d, onClick: i, children: u ?? /* @__PURE__ */ e("span", { className: "truncate max-w-[200px]", children: m }) }) : /* @__PURE__ */ e("a", { href: d ? void 0 : s, children: u ?? /* @__PURE__ */ e("span", { className: "truncate max-w-[200px]", children: m }) }) }) }) })
      ] }) }),
      o?.nested ? /* @__PURE__ */ e(We, { nested: o.nested, selectedItemId: o.selectedNestedId }) : /* @__PURE__ */ e(x, { icon: "Down", style: { transform: "rotateZ(-90deg)" }, size: 16 })
    ] }) : null,
    t.length > 1 && /* @__PURE__ */ e(F, { collection: l, children: (s, i) => /* @__PURE__ */ e(De, { ...s, isLast: i === l.length - 1 }) })
  ] }) });
}
function We({
  nested: t,
  selectedItemId: a
}) {
  const [n, o] = st((r) => r());
  if (Q(() => {
    typeof t == "function" && n(t);
  }, []), typeof t == "function")
    switch (o.kind) {
      case "error":
        return null;
      case "initial":
        return /* @__PURE__ */ e(x, { icon: "Down", style: { transform: "rotateZ(-90deg)" }, size: 16 });
      case "loading":
        return /* @__PURE__ */ e(Ce, {});
      case "success":
        return /* @__PURE__ */ e(de, { items: o.result, selectedItemId: a });
      default:
        return we();
    }
  if ("kind" in t)
    switch (t.kind) {
      case "loading":
        return /* @__PURE__ */ e(Ce, {});
      case "success":
        return /* @__PURE__ */ e(de, { items: t.result, selectedItemId: a });
      case "error":
        return null;
      case "initial":
        return /* @__PURE__ */ e(x, { icon: "Down", style: { transform: "rotateZ(-90deg)" }, size: 16 });
      default:
        return we();
    }
  return /* @__PURE__ */ e(de, { items: t, selectedItemId: a });
}
function De(t) {
  const { label: a, children: n, disabled: o, href: r, icon: l, nested: s, onClick: i, selectedNestedId: d, isLast: u } = t;
  return /* @__PURE__ */ p(Pe, { className: "flex items-center gap-2", children: [
    /* @__PURE__ */ e(
      rt,
      {
        "aria-disabled": o,
        asChild: !0,
        onClick: i,
        className: "max-w-20 truncate md:max-w-none",
        ...O(t),
        ...u ? ue("Title/S") : ue("Title/S/Light"),
        children: r ? /* @__PURE__ */ p("a", { href: o ? void 0 : r, className: "max-w-20 truncate md:max-w-none flex items-center gap-2", children: [
          l && (typeof l == "string" && M(l) ? /* @__PURE__ */ e(x, { icon: l }) : l),
          n ?? a
        ] }) : i ? /* @__PURE__ */ p("button", { type: "button", disabled: o, className: "max-w-20 truncate md:max-w-none flex items-center gap-2", children: [
          l && (typeof l == "string" && M(l) ? /* @__PURE__ */ e(x, { icon: l }) : l),
          n ?? a
        ] }) : /* @__PURE__ */ p(lt, { className: "max-w-20 truncate md:max-w-none flex items-center gap-2", children: [
          l && (typeof l == "string" && M(l) ? /* @__PURE__ */ e(x, { icon: l }) : l),
          n ?? a
        ] })
      }
    ),
    s ? /* @__PURE__ */ e(We, { nested: s, selectedItemId: d }) : !u && /* @__PURE__ */ e(x, { icon: "Down", style: { transform: "rotateZ(-90deg)" }, size: 16 })
  ] });
}
function de(t) {
  return t.items.length >= 5 ? /* @__PURE__ */ e(Rt, { ...t }) : /* @__PURE__ */ e(Pt, { ...t });
}
function Pt({
  items: t,
  selectedItemId: a
}) {
  return /* @__PURE__ */ p(Re, { modal: !1, children: [
    /* @__PURE__ */ e(
      ze,
      {
        disabled: t.length === 0,
        className: "flex items-center gap-1 disabled:opacity-70",
        "aria-label": "Toggle menu",
        children: /* @__PURE__ */ e(x, { icon: "Down", style: { transform: "rotateZ(-90deg)" }, size: 16 })
      }
    ),
    /* @__PURE__ */ e(Oe, { align: "start", children: /* @__PURE__ */ e(F, { collection: t, children: ({ onClick: n, href: o, disabled: r, label: l, children: s, icon: i, id: d }) => /* @__PURE__ */ e(
      Ee,
      {
        className: "gap-2",
        asChild: !0,
        disabled: r,
        "aria-current": d !== void 0 && d === a,
        children: n ? /* @__PURE__ */ p(pe, { disabled: r, onClick: n, children: [
          i && (typeof i == "string" && M(i) ? /* @__PURE__ */ e(x, { icon: i }) : i),
          s ?? l
        ] }) : /* @__PURE__ */ p("a", { href: r ? void 0 : o, children: [
          i && (typeof i == "string" && M(i) ? /* @__PURE__ */ e(x, { icon: i }) : i),
          s ?? l
        ] })
      },
      `${d}-${l}`
    ) }) })
  ] });
}
function Rt({
  items: t,
  selectedItemId: a
}) {
  const n = J(), [o, r] = Y(!1);
  return /* @__PURE__ */ p(Ae, { modal: !1, open: o, onOpenChange: r, children: [
    /* @__PURE__ */ e(
      it,
      {
        disabled: t.length === 0,
        className: "flex items-center gap-1 disabled:opacity-70",
        "aria-label": "Toggle menu",
        children: /* @__PURE__ */ e(x, { icon: "Down", style: { transform: "rotateZ(-90deg)" }, size: 16 })
      }
    ),
    /* @__PURE__ */ e($e, { align: "start", children: /* @__PURE__ */ p(Me, { loop: !0, defaultValue: "-", children: [
      /* @__PURE__ */ e(ot, { className: "-mt-1", placeholder: "Search..." }),
      /* @__PURE__ */ p(Le, { children: [
        /* @__PURE__ */ e(Fe, { children: "No results found" }),
        /* @__PURE__ */ e(F, { collection: t, children: ({ onClick: l, href: s, disabled: i, label: d, children: u, icon: m, id: f }) => /* @__PURE__ */ e(
          Te,
          {
            onSelect: (h) => {
              document.querySelector(`[data-id="${CSS.escape(h)}"]`)?.click(), r(!1);
            },
            className: "gap-2",
            asChild: !0,
            disabled: i,
            "aria-current": f !== void 0 && f === a,
            "data-id": `${n}-${f}-${d}`,
            value: `${n}-${f}-${d}`,
            children: l ? /* @__PURE__ */ p(
              pe,
              {
                disabled: i,
                onClick: () => {
                  l(), r(!1);
                },
                children: [
                  m && (typeof m == "string" && M(m) ? /* @__PURE__ */ e(x, { icon: m }) : m),
                  u ?? d
                ]
              }
            ) : /* @__PURE__ */ p("a", { onClick: i ? void 0 : () => r(!1), href: i ? void 0 : s, children: [
              m && (typeof m == "string" && M(m) ? /* @__PURE__ */ e(x, { icon: m }) : m),
              u ?? d
            ] })
          },
          `${f}-${d}`
        ) })
      ] })
    ] }) })
  ] });
}
function ha({ children: t, color: a = "var(--palette-P400)", count: n }) {
  return /* @__PURE__ */ p(At, { position: "relative", children: [
    /* @__PURE__ */ e("div", { className: "relative", children: t }),
    /* @__PURE__ */ e(
      "div",
      {
        className: ct("-top-1 -right-1 rounded-full flex items-center justify-center text-white", {
          "min-w-5 h-5": n != null,
          "w-3 h-3 top-0 right-0": n == null
        }),
        style: { backgroundColor: a },
        children: n
      }
    )
  ] });
}
function zt({ className: t, ...a }) {
  return /* @__PURE__ */ e(
    Mt.Root,
    {
      "data-slot": "label",
      className: B(
        "text-sm leading-none font-medium group-data-[disabled=true]:pointer-events-none group-data-[disabled=true]:opacity-50 peer-disabled:cursor-not-allowed peer-disabled:opacity-50",
        t
      ),
      ...a
    }
  );
}
const Ot = "text-[12px] leading-[16px] text-(--palette-N500) font-semibold";
function Et({ htmlFor: t, children: a, className: n, style: o, innerRef: r, ...l }) {
  return /* @__PURE__ */ e(
    zt,
    {
      ref: r,
      htmlFor: t,
      className: E(Ot, n),
      style: o,
      ...O(l),
      children: k(a)
    }
  );
}
function ga({ label: t, error: a, hint: n, className: o, style: r, children: l, innerRef: s, ...i }) {
  const d = J(), u = !!a;
  return /* @__PURE__ */ p(
    dt,
    {
      ref: s,
      className: E("", o),
      style: r,
      "data-invalid": u,
      ...O(i),
      children: [
        typeof t == "string" ? (
          // The wrapping div is legacy's, and it is what keeps the label from being stretched by the
          // column: without it the `<label>` is a flex item and its focus/hover box spans the row.
          /* @__PURE__ */ e("div", { children: /* @__PURE__ */ e(Et, { htmlFor: d, children: t }) })
        ) : k(t, { htmlFor: d }),
        k(l, { id: d, invalid: u }),
        a && /* @__PURE__ */ e("div", { className: "mt-1", children: /* @__PURE__ */ e(Ie, { severity: "error", children: k(a) }) }),
        n && !a && /* @__PURE__ */ e("div", { className: "mt-1", children: /* @__PURE__ */ e(Ie, { severity: "info", children: k(n) }) })
      ]
    }
  );
}
function xa({ value: t, children: a, className: n, style: o, ...r }) {
  return t != null ? /* @__PURE__ */ e(U, { children: a(t) }) : /* @__PURE__ */ e($t, { className: X(n), style: o, ...r });
}
function Gt(t) {
  return Number.isNaN(t) ? null : t;
}
function ya({
  onChange: t,
  onBlur: a,
  value: n,
  innerRef: o,
  step: r,
  min: l,
  max: s,
  ...i
}) {
  const d = Ge(null, o);
  return /* @__PURE__ */ e(
    ut,
    {
      value: String(n ?? ""),
      onChange: () => {
        if (!d.current) {
          console.warn("[NumberInput] missing input ref in onChange handler");
          return;
        }
        let u = Gt(d.current.valueAsNumber);
        u != null && r != null && (u = St(u, r)), u != null && (u = _e(u, l ?? -1 / 0, s ?? 1 / 0)), t?.(u);
      },
      children: ({ value: u, onChange: m, onCommit: f }) => /* @__PURE__ */ e(
        Ve,
        {
          ...i,
          step: r,
          min: l,
          max: s,
          innerRef: d,
          type: "number",
          value: u,
          onChange: (h) => m(h.currentTarget.value),
          onBlur: (h) => {
            f(), a?.(h);
          },
          onScroll: (h) => h.currentTarget.blur(),
          onWheel: (h) => h.currentTarget.blur()
        }
      )
    }
  );
}
const ba = ({
  currentPage: t,
  totalResults: a,
  onPageChange: n,
  pageSize: o = 10,
  pageSizeOptions: r = [10, 20, 30, 50, 100],
  onPageSizeChange: l,
  disabled: s = !1,
  className: i
}) => {
  const d = Math.ceil(a / o), u = d === 0, m = t <= 1 || u, f = t >= d || u, h = L(() => r.map((y) => ({ label: String(y), value: y })), [r]);
  return /* @__PURE__ */ p(
    "nav",
    {
      className: X(mt("flex items-center justify-between gap-4", i)),
      "aria-label": "Pagination",
      children: [
        l && /* @__PURE__ */ p(K, { gap: "0.5rem", alignItems: "center", flexGrow: 0, children: [
          /* @__PURE__ */ e(I, { type: "Body/M/Book", children: "Page Size:" }),
          /* @__PURE__ */ e(
            pt,
            {
              multi: !1,
              value: o,
              options: h,
              onChange: (y) => y != null && l(y),
              placeholder: "Select page size",
              size: "small"
            }
          )
        ] }),
        /* @__PURE__ */ p(K, { alignItems: "center", className: "px-2", "aria-live": "polite", "aria-atomic": "true", flexGrow: 0, children: [
          /* @__PURE__ */ e(I, { type: "Body/M/Book", children: Math.min(a, (t - 1) * o + 1) }),
          /* @__PURE__ */ e(I, { type: "Body/M/Book", className: "mx-1", children: "to" }),
          /* @__PURE__ */ e(I, { type: "Body/M/Book", children: Math.min(a, t * o) }),
          /* @__PURE__ */ e(I, { type: "Body/M/Book", className: "mx-1", children: "of" }),
          /* @__PURE__ */ e(I, { type: "Body/M/Book", children: a })
        ] }),
        /* @__PURE__ */ p(K, { gap: "0.5rem", alignItems: "center", flexGrow: 0, children: [
          /* @__PURE__ */ e(
            j,
            {
              onClick: () => n(1),
              disabled: m || s,
              icon: "Double-left",
              color: m || s ? S.palette_N300 : S.palette_N500,
              "aria-label": "Go to the first page"
            }
          ),
          /* @__PURE__ */ e(
            j,
            {
              onClick: () => n(t - 1),
              disabled: m || s,
              icon: "Left",
              color: m || s ? S.palette_N300 : S.palette_N500,
              "aria-label": "Go to previous page"
            }
          ),
          /* @__PURE__ */ p(K, { alignItems: "center", className: "px-2", "aria-live": "polite", "aria-atomic": "true", flexGrow: 0, children: [
            /* @__PURE__ */ p(I, { type: "Body/M/Book", children: [
              "Page ",
              t
            ] }),
            /* @__PURE__ */ e(I, { type: "Body/M/Book", className: "mx-1", children: "of" }),
            /* @__PURE__ */ e(I, { type: "Body/M/Book", children: d })
          ] }),
          /* @__PURE__ */ e(
            j,
            {
              onClick: () => n(t + 1),
              disabled: f || s,
              icon: "Right",
              color: f || s ? S.palette_N300 : S.palette_N500,
              "aria-label": "Go to next page"
            }
          ),
          /* @__PURE__ */ e(
            j,
            {
              onClick: () => n(d),
              disabled: f || s,
              icon: "Double-right",
              color: f || s ? S.palette_N300 : S.palette_N500,
              "aria-label": "Go to the last page"
            }
          )
        ] })
      ]
    }
  );
}, Vt = {
  togglePasswordVisibility: (t) => t ? "Hide password" : "Show password"
};
function Na({ onChangeText: t, i18n: a, rightContent: n, leftContent: o, ...r }) {
  const l = ft({ fallback: Vt, overrides: a }), [s, i] = Y(!1);
  return /* @__PURE__ */ e(
    Ve,
    {
      onChangeText: t,
      type: s ? "text" : "password",
      autoTrimOnBlur: !1,
      rightContent: k(n, {
        passwordVisible: s,
        onPasswordVisibleChange: i
      }) ?? /* @__PURE__ */ e(
        "button",
        {
          title: l.togglePasswordVisibility(s),
          type: "button",
          className: "inline-flex",
          onClick: () => i(!s),
          children: /* @__PURE__ */ e(x, { icon: s ? "show" : "Hide" })
        }
      ),
      leftContent: k(o, {
        passwordVisible: s,
        onPasswordVisibleChange: i
      }),
      ...r
    }
  );
}
function va({ color: t = "var(--palette-P400)", count: a }) {
  return /* @__PURE__ */ e(
    "div",
    {
      className: `ml-2 rounded-sm flex items-center justify-center text-white " ${a != null && "min-w-5 h-6"}
				${a == null && "w-3 h-3 top-0 right-0"}`,
      style: { backgroundColor: t },
      children: a
    }
  );
}
const Se = {
  large: "h-[38px] px-[10px] text-[16px]",
  small: "h-[34px] px-[9px] text-[12px]",
  "x-small": "h-[26px] px-[6px] text-[12px]"
}, _t = {
  large: "h-[38px] px-2 text-[16px]",
  small: "h-[34px] px-2 text-[12px]",
  "x-small": "h-[26px] px-2 text-[12px]"
};
function wa({
  value: t,
  onChange: a,
  onClear: n,
  min: o,
  max: r,
  step: l = 1,
  size: s = "small",
  disabled: i,
  className: d,
  id: u,
  invalid: m
}) {
  const [f, h] = Be(t !== null ? String(t) : "");
  function y(v) {
    return _e(v, o ?? -1 / 0, r ?? 1 / 0);
  }
  function D() {
    t !== null && a(y(t - l));
  }
  function T() {
    a(y(t !== null ? t + l : o ?? 0));
  }
  function P(v) {
    h(v.target.value);
  }
  function w() {
    if (n && f.trim() === "") {
      n();
      return;
    }
    const v = parseFloat(f);
    if (Number.isNaN(v))
      h(t !== null ? String(t) : "");
    else {
      const G = y(v);
      a(G), h(String(G));
    }
  }
  function $(v) {
    v.key === "Enter" && v.currentTarget.blur();
  }
  const ee = t === null || o !== void 0 && t <= o, te = r !== void 0 && t !== null && t >= r;
  return /* @__PURE__ */ p(ht, { className: B(X(d)), children: [
    /* @__PURE__ */ e(
      ke,
      {
        type: "button",
        variant: "outline",
        className: B("shadow-none", Se[s]),
        disabled: i || ee,
        onClick: D,
        children: "-"
      }
    ),
    /* @__PURE__ */ e(
      "input",
      {
        id: u,
        type: "text",
        inputMode: "numeric",
        value: f,
        onChange: P,
        onBlur: w,
        onKeyDown: $,
        disabled: i,
        className: B(
          "border-input bg-background text-center tabular-nums",
          "border focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring focus-visible:relative focus-visible:z-10",
          "disabled:pointer-events-none disabled:opacity-50",
          "w-16",
          _t[s],
          m && "border-destructive"
        )
      }
    ),
    /* @__PURE__ */ e(
      ke,
      {
        type: "button",
        variant: "outline",
        className: B("shadow-none", Se[s]),
        disabled: i || te,
        onClick: T,
        children: "+"
      }
    )
  ] });
}
function Ca({
  innerRef: t,
  disabled: a,
  palette: n = "primary",
  ...o
}) {
  const r = gt(), l = Ge(null, t), s = r.submitter === null || r.submitter === l.current;
  return /* @__PURE__ */ e(
    xt,
    {
      ...o,
      innerRef: l,
      type: "submit",
      palette: n,
      disabled: a ?? r.state === "loading",
      state: yt(s ? r.state : "initial", {
        progress: r.progress,
        err: r.error,
        result: r.result
      }),
      progressBar: s && typeof r.progress == "number"
    }
  );
}
function Ia({
  // Defaulted for the same reason as {@link Checkbox}: Radix reads `undefined` as "uncontrolled",
  // and the form field wrappers forward react-hook-form's untyped `field.value`, so an unseeded
  // default reaches here as `undefined` with no type error and silently detaches the control from
  // the form. The legacy component this replaces defaulted it too.
  checked: t = !1,
  onChange: a,
  onClick: n,
  children: o,
  className: r,
  style: l,
  disabled: s = !1,
  invalid: i = !1,
  labelPosition: d = "end",
  name: u,
  id: m,
  innerRef: f,
  ...h
}) {
  const y = J(), D = m ?? y;
  return (
    // data-* on the WRAPPER, and the two suppressions below are the same propagation-barrier case
    // documented at length on `Checkbox` — every call site that passes `onClick` passes
    // `e.stopPropagation()` and nothing else, and the element that is actually activated is the
    // Radix control inside, which is already keyboard-operable.
    //
    // biome-ignore lint/a11y/noStaticElementInteractions: propagation barrier, not an action
    // biome-ignore lint/a11y/useKeyWithClickEvents: propagation barrier, not an action
    /* @__PURE__ */ e(
      "span",
      {
        ref: f,
        className: E("inline-flex relative", r),
        style: l,
        onClick: n,
        ...h,
        children: /* @__PURE__ */ e(bt, { controlId: D, disabled: s, labelPosition: d, label: o, children: /* @__PURE__ */ e(
          Lt,
          {
            id: D,
            name: u,
            disabled: s,
            checked: t,
            "data-invalid": i,
            className: X({ "ring-2 ring-(--palette-D500)": i && !s }),
            onCheckedChange: a
          }
        ) })
      }
    )
  );
}
const Wt = {
  large: "text-[16px] py-[7px] px-2.5",
  small: "text-[14px] py-[5px] px-2",
  "x-small": "text-[12px] py-1 px-1"
};
function ka({
  className: t,
  style: a,
  onChange: n,
  onChangeText: o,
  onBlur: r,
  autoTrimOnBlur: l = !0,
  rows: s,
  size: i = "small",
  invalid: d,
  id: u,
  innerRef: m,
  textAreaAppearance: f,
  ...h
}) {
  const [y, D] = Nt(h);
  function T(w) {
    n?.(w), o?.(w.currentTarget.value);
  }
  function P(w) {
    if (l) {
      const $ = w.currentTarget.value.trim();
      $ !== w.currentTarget.value && o?.($);
    }
    r?.(w);
  }
  return /* @__PURE__ */ e("div", { className: E(It, t), style: a, ...y, children: /* @__PURE__ */ e(
    vt,
    {
      id: u,
      "data-invalid": d,
      ref: m,
      style: { ...f?.style },
      rows: s ?? 4,
      className: E(
        B(
          Ct,
          "overflow-y-auto text-ellipsis",
          wt,
          // The primitive's own min-height would stop a rows={1} field from being one line high,
          // which is the exact row-jump HistoryBox's inline rename is written to avoid.
          "min-h-0",
          Wt[i]
        ),
        f?.className
      ),
      onChange: T,
      onBlur: P,
      ...D
    }
  ) });
}
export {
  ma as Autocomplete,
  fa as Breadcrumbs,
  Ba as BulkActions,
  xt as Button,
  Ma as Checkbox,
  Aa as DatePickerInput,
  $a as DatePickerInputCtx,
  ha as DotCounter,
  La as DropdownMenu,
  Fa as Form,
  Ta as FormContext,
  ga as FormField,
  Pa as HierarchicalSelect,
  j as IconButton,
  Et as Label,
  xa as MaybeSkeleton,
  Ra as MultipleHierarchicalSelect,
  ya as NumberInput,
  ba as Pagination,
  Na as PasswordInput,
  za as Radio,
  Oa as RadioGroup,
  va as RectangularCounter,
  pt as Select,
  wa as StepperInput,
  Ca as SubmitButton,
  Ia as Switch,
  ka as TextArea,
  Ve as TextInput,
  bt as ToggleLabel,
  E as applyClassOverride,
  Ea as clampDate,
  Ga as createLeafPathFromValue,
  Va as defaultDatePickerInputI18n,
  Vt as defaultPasswordInputI18n,
  _a as excludeDataAttrs,
  Ct as fieldBaseClassName,
  It as fieldWrapperClassName,
  Wa as inputSizeClassName,
  Ot as labelClassName,
  Za as normaliseDateEntry,
  O as pickDataAttrs,
  Qe as popoverMaxHeight,
  Ye as popoverMaxWidth,
  wt as primitiveResetClassName,
  qa as splitAriaAttrs,
  Nt as splitDataAttrs,
  Wt as textAreaSizeClassName,
  Ue as triggerBaseClassName,
  je as triggerSizeClassName,
  Ha as unstyledFieldClassName,
  Ka as unstyledResetClassName,
  ja as unstyledWrapperClassName,
  gt as useFormSubmitState
};
//# sourceMappingURL=index.js.map
